var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTickCirclePurple = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.98865C0 3.57664 3.57664 0 7.98865 0C12.3985 0.00520243 15.9721 3.5788 15.9773 7.98865C15.9773 12.4007 12.4007 15.9773 7.98865 15.9773C3.57664 15.9773 0 12.4007 0 7.98865ZM7.26242 8.77734L10.3802 5.65958C10.6651 5.38436 11.1181 5.38829 11.3982 5.66843C11.6784 5.94857 11.6823 6.40153 11.4071 6.68649L7.77587 10.3177C7.49227 10.6012 7.03256 10.6012 6.74897 10.3177L4.57024 8.13897C4.38145 7.95663 4.30574 7.68661 4.3722 7.4327C4.43866 7.17878 4.63696 6.98048 4.89087 6.91402C5.14479 6.84756 5.41481 6.92327 5.59715 7.11207L7.26242 8.77734Z",
    fill: "#3030AD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTickCirclePurple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tickCirclePurple.058d2d059062d0c48a312687922b5219.svg";